module.exports = __webpack_public_path__ + "static/img/listSc.f450155.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/listSc.jpg
// module id = AJUn
// module chunks = 1